export const isDevServer = /^localhost:\d+$/.test(window.location.host)

export const getSubDomain = (url: string) => {
	if (!url.includes(".")) {
		throw new Error(`Unable to get subdomain from '${url}'`)
	}
	return url.split(".")[0]
}

export const getDomain = (url: string) => {
	if (!url.includes(".")) {
		throw new Error(`Unable to get domain from '${url}'`)
	}

	return url.substring(url.indexOf(".") + 1)
}

const getApiUrl = () => {
	if (isDevServer) {
		return "https://api.localhost.com"
	}

	const domain = getDomain(window.location.host)

	return `https://api.${domain}`
}

export const apiUrl = getApiUrl()

const getEchoUrl = () => {
	if (isDevServer) {
		return "https://echo.devm.co:5187"
	}

	let domain = getDomain(window.location.host)

	if (domain == "localhost.com") {
		domain = "devm.co:5187"
	}

	return `https://echo.${domain}:5187`
}

export const echoUrl = getEchoUrl()
